var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsNumber, IsString } from 'class-validator';
import { UpdatePreventionCourseModuleDto } from './update-prevention-course-module.dto.js';
export class UpdatePreventionCourseDto {
    title;
    thumbnailImage;
    price;
    shortDescription;
    longDescription;
    contactEmail;
    contactName;
    preventionCourseModules;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], UpdatePreventionCourseDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], UpdatePreventionCourseDto.prototype, "thumbnailImage", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], UpdatePreventionCourseDto.prototype, "price", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], UpdatePreventionCourseDto.prototype, "shortDescription", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], UpdatePreventionCourseDto.prototype, "longDescription", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], UpdatePreventionCourseDto.prototype, "contactEmail", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], UpdatePreventionCourseDto.prototype, "contactName", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => UpdatePreventionCourseModuleDto),
    __metadata("design:type", Array)
], UpdatePreventionCourseDto.prototype, "preventionCourseModules", void 0);
//# sourceMappingURL=update-prevention-course.dto.js.map